// AboutMe.js
import React from "react";
import "./AboutMe.css";

function AboutMe() {
  const Admin = {
    name: "Hamza Aleem",
    imageUrl: require("../images/hamza.png"),
  };
  return (
    <section id="about" className="about-section">
      <div className="about-container">
        <div className="profile-picture">
          <img
            src={Admin.imageUrl}
            alt={Admin.name}
            className="admin-image"
            style={{
              width: "150px",
              height: "150px",
              objectFit: "cover",
            }}
          />
        </div>
        <div className="about-content">
          <h2>About Me</h2>
          <p>
            I am an Electrical Engineer passionate about Artificial
            Intelligence, Machine Learning, and Generative AI. I enjoy solving
            complex problems and building innovative solutions that have
            real-world impact.
          </p>
        </div>
      </div>
    </section>
  );
}

export default AboutMe;
